export const appVersion = import.meta.env.VITE_TAG || 'v1.0'
export const name = import.meta.env.VITE_NAME
export const title = import.meta.env.VITE_TITLE
export const logo = import.meta.env.VITE_LOGO
export const footerLinks = JSON.parse(
  import.meta.env.VITE_FOOTER_LINKS || '[]'
)
export const blockExplorer = import.meta.env.VITE_BLOCK_EXPLORER_URL
export const developmentMode = import.meta.env.VITE_ENV === 'dev'
